import { render, staticRenderFns } from "./AssistanceSummary.vue?vue&type=template&id=0e33c012&"
import script from "./AssistanceSummary.vue?vue&type=script&lang=js&"
export * from "./AssistanceSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports